import React from 'react'
import MovieTabs2 from './MovieTabs2'

function Section3() {
  return (
    <section className=' px-6 mt-40 md:px-16 lg:px-28 relative'>
      {/* ----------------------- Category Button Selection ------------------- */}
      <MovieTabs2/>
    </section>
  )
}

export default Section3